// import { useEffect, useMemo, useRef, useState } from "react";
// import { initialExercisePreferences } from "data/dropdowndData/dropdownsData";
// import { ReactComponent as ExeciseEdit } from "@assets/images/ExerciseEdit.svg";
// import GenerateExcercise from "@features/exercise/GenerateExcercise";
// import { toast } from "react-toastify";
// import ButtonLoader from "@components/ui/Loaders/ButtonLoader";
// import NotFound from "@components/ui/NotFound";
// import ActualDietPlanLoader from "@components/ui/Loaders/ActualDietPlanLoader";
// import { SaveAllIcon } from "lucide-react";
// import AlertDialog from "@components/ui/ConfirmDialogue";
// import BackImg from "@assets/images/stepsBack.jpg";
// import ExerciseGeneratingLoader from "@components/ui/Loaders/ExerciseGeneratingLoader";
// import { useUserData } from "context/OAuth/AuthContext";
// import { useNavigate } from "react-router-dom";
// import MainHeader from "@components/ui/MainHeader";
// import HeaderImage from "@assets/images/exercisePlanHeader.svg";
// import { useTranslation } from "react-i18next";

// import {
//   generateExercisePlan,
//   getExerciseCategories,
//   saveExerciseCategories,
//   getExercisePlan,
// } from "api/exercisePlan";
// import ExercisePlanMultiSelectDropdown from "@components/ui/customDropdowns/ExercisePlanMultiSelectDropdown";
// import useExercisePlanTimer from "@utils/ExercisePlanProgress";
// import { useMeta } from "context/ExerciseMeta";
// import { icons, localExercisePreferences } from "data/uiData/ExercisePlan";

// const ExerciseDashboard = () => {
//   const { subscription, language } = useUserData();
//   const navigate = useNavigate();
//   const { t } = useTranslation();
//   const [exercisePlan, setExercisePlan] = useState([]);
//   // Removed unused states: exerciseLocation, WeightGoal, gainMuscle
//   const [errors, setErrors] = useState({});
//   const [open, setOpen] = useState(false);
//   const [firstLoad, setFirstLoad] = useState(true);
//   const [planInitiateTime, setPlanInitiateTime] = useState(null);
//   const [selectedTags, setSelectedTags] = useState(initialExercisePreferences);
//   const { timeLeft, setTimeLeft, stopCountdown } = useExercisePlanTimer(
//     planInitiateTime,
//     900
//   );
//   const [message, setMessage] = useState("25");
//   // NEW STATE to hold dynamically fetched options
//   const { dynamicOptions } = useMeta();
//   const [saveLoad, setSaveLoad] = useState(false);
//   const [generatePlanLoading, setGeneratePlanLoading] = useState(false);
//   const exerciseCheck = exercisePlan?.length > 0;

//   // Helper function to find option by ID (for equipment and workouts)
//   const findOptionById = (key, id) => {
//     const options = dynamicOptions[key];
//     if (!options || !Array.isArray(options)) return null;

//     return options.find((opt) => opt.id === id);
//   };

//   const setExercisePlanData = (data, isPending) => {
//     setPlanInitiateTime(data?.start_time || null);
//     setExercisePlan(data?.plan || null);
//     setGeneratePlanLoading(isPending);
//   };

//   // Data Fetching Functions
//   const handleFetchExercise = async (newPlan = false) => {
//     try {
//       const exercisePlanInfo = await getExercisePlan();
//       const data = exercisePlanInfo.data;
//       const isPending = data?.is_pending;
//       setMessage(data?.loader_status);
//       if (newPlan) {
//         stopCountdown();
//         toast.info(t("Your new Exercise Plan created successfully!"));
//       }
//       setExercisePlanData(data, isPending);
//     } catch (error) {
//       console.log("error fetching exercise plan");
//     }
//   };

//   const validateAndMapSavedData = (savedFields, currentDynamicOptions) => {
//     const validatedData = {};

//     // Equipment Categories - single select (store ID)
//     if (savedFields.equipmentCategories) {
//       const equipmentOption = currentDynamicOptions.equipmentCategories.find(
//         (opt) => opt.id === savedFields.equipmentCategories
//       );
//       validatedData.equipmentCategories = equipmentOption
//         ? savedFields.equipmentCategories
//         : null;
//     }

//     // Difficulties Level - single select (store value directly as it's simple string)
//     if (savedFields.difficultiesLevel) {
//       const difficultyExists = currentDynamicOptions.difficultiesLevel.includes(
//         savedFields.difficultiesLevel
//       );
//       validatedData.difficultiesLevel = difficultyExists
//         ? savedFields.difficultiesLevel
//         : null;
//     }

//     // Workouts Categories - multi-select (store array of IDs)
//     if (Array.isArray(savedFields.workoutsCategories)) {
//       validatedData.workoutsCategories = savedFields.workoutsCategories.filter(
//         (id) => {
//           return (
//             currentDynamicOptions.workoutsCategories.find(
//               (opt) => opt.id === id
//             ) !== undefined
//           );
//         }
//       );
//     }

//     return validatedData;
//   };

//   const handleFetchCatgories = async () => {
//     try {
//       const response = await getExerciseCategories();
//       await handleFetchExercise();

//       const { fields = {} } = response?.data?.data || {};

//       // 3. Validate and map saved values to appropriate format using the current options
//       const validatedData = validateAndMapSavedData(fields, dynamicOptions);

//       // 4. Merge with initial preferences (fallback if no valid data)
//       const data = {
//         equipmentCategories:
//           validatedData.equipmentCategories ||
//           initialExercisePreferences.equipmentCategories,
//         difficultiesLevel:
//           validatedData.difficultiesLevel ||
//           initialExercisePreferences.difficultiesLevel,
//         workoutsCategories:
//           validatedData.workoutsCategories ||
//           initialExercisePreferences.workoutsCategories,
//       };

//       setSelectedTags(data);
//       setTimeout(() => {
//         setFirstLoad(false);
//       }, 1000);
//     } catch (error) {
//       console.error("Error fetching categories:", error);
//       setTimeout(() => {
//         setFirstLoad(false);
//       }, 1000);
//     }
//   };

//   const getSavePayload = () => {
//     const payload = {};
//     // Equipment Categories - store ID
//     payload.equipmentCategories = selectedTags.equipmentCategories;
//     // Difficulties Level - store value directly
//     payload.difficultiesLevel = selectedTags.difficultiesLevel;
//     // Workouts Categories - store array of IDs
//     payload.workoutsCategories = selectedTags.workoutsCategories;

//     return payload;
//   };

//   const handleSaveCategories = async () => {
//     setSaveLoad(true);
//     try {
//       const payload = getSavePayload();
//       // const createPlanPayload = buildExercisePayload(
//       //   selectedTags,
//       //   dynamicOptions
//       // );
//       await saveExerciseCategories(payload);
//       await handleGeneratePlan();
//     } catch (error) {
//       console.error(error);
//       toast.error(t("toast.failedSubmit"));
//     } finally {
//       setSaveLoad(false);
//     }
//   };

//   const handleGeneratePlan = async () => {
//     try {
//       const response = await generateExercisePlan();
//       setPlanInitiateTime(response?.start_time);
//       setMessage(response?.loader_status);
//       // setTimeout(() => {
//       if (response?.is_pending) {
//         setGeneratePlanLoading(true);
//         toast.info(t("toast.Plan creation process has been initiated."));
//       } else {
//         toast.info(t("toast.We’ve found a matching plan for you!"));
//         setExercisePlanData(response, response?.is_pending);
//       }
//       // }, 1000);
//     } catch (error) {
//       toast.error(t("toast.Failed to save plan."));
//       console.log(error);
//     }
//   };

//   const handleClose = (key) => {
//     if (key === "cancel") {
//       setOpen(false);
//     } else {
//       handleSaveCategories();
//       setOpen(false);
//     }
//   };

//   const validateStep = () => {
//     let isValid = true;
//     const newErrors = {};

//     for (const field of localExercisePreferences) {
//       const value = selectedTags[field.key];
//       const fieldLabel = t(`firstFormSteps.${field.key}.label`);

//       if (field.type === "multi-select") {
//         if (!Array.isArray(value) || value.length === 0) {
//           newErrors[field.key] = t("validation.required", {
//             field: fieldLabel,
//           });
//           isValid = false;
//         }
//       } else if (field.type === "select") {
//         if (!value || value === "") {
//           newErrors[field.key] = t("validation.required", {
//             field: fieldLabel,
//           });
//           isValid = false;
//         }
//       }
//     }

//     setErrors(newErrors);
//     return isValid;
//   };

//   const handleClickOpen = () => {
//     if (validateStep()) {
//       setOpen(true);
//     } else {
//       toast.error(t("toast.oopsIncorrect"));
//     }
//   };

//   useEffect(() => {
//     handleFetchCatgories(); // This now handles fetching both static and dynamic options
//   }, []);

//   const handleMultiSelectChange = (key, values) => {
//     setSelectedTags((prev) => ({ ...prev, [key]: values }));

//     setErrors((prevErrors) => {
//       const updatedErrors = { ...prevErrors };
//       if (!values || values.length === 0) {
//         updatedErrors[key] = true;
//       } else {
//         delete updatedErrors[key];
//       }
//       return updatedErrors;
//     });
//   };

//   const handleSelectChange = (key, value) => {
//     setSelectedTags((prev) => ({ ...prev, [key]: value }));

//     setErrors((prevErrors) => {
//       const updatedErrors = { ...prevErrors };
//       if (!value || value === "") {
//         updatedErrors[key] = true;
//       } else {
//         delete updatedErrors[key];
//       }
//       return updatedErrors;
//     });
//   };

//   const removeTag = (key, itemValue) => {
//     const updated = selectedTags[key].filter((item) => item !== itemValue);

//     if (updated.length === 0) {
//       setErrors((prev) => ({ ...prev, [key]: true }));
//     }

//     setSelectedTags((prev) => ({
//       ...prev,
//       [key]: updated,
//     }));
//   };

//   /**
//    * Gets display label for a given value/ID
//    */
//   const getDisplayLabel = (key, value) => {
//     if (key === "difficultiesLevel") {
//       // Difficulties are simple strings, not IDs
//       return value ? value.charAt(0).toUpperCase() + value.slice(1) : value;
//     }

//     // For equipment and workouts, find by ID
//     const option = findOptionById(key, value);
//     return option ? option.name : "Unknown";
//   };

//   /**
//    * Gets dropdown options for each field type
//    */
//   const getDropdownOptions = (key) => {
//     const options = dynamicOptions[key] || [];

//     if (key === "difficultiesLevel") {
//       // Simple array of strings - store value directly
//       return options.map((opt) => ({
//         value: opt, // Store the value directly
//         label: opt.charAt(0).toUpperCase() + opt.slice(1),
//       }));
//     } else {
//       // Array of objects - store the ID
//       return options.map((opt) => ({
//         value: opt.id, // Store ID as value
//         label: opt.name, // Display name
//       }));
//     }
//   };

//   return (
//     <div className={`${firstLoad && "h-[100%]"}`}>
//       {firstLoad ? (
//         <ActualDietPlanLoader exercisePlan={true} />
//       ) : !exerciseCheck && generatePlanLoading ? (
//         <ExerciseGeneratingLoader
//           planInitiateTime={planInitiateTime}
//           exercisePlan={true}
//           handleFetchExercise={handleFetchExercise}
//           setGeneratePlanLoading={setGeneratePlanLoading}
//           timeLeft={timeLeft}
//           setTimeLeft={setTimeLeft}
//           message={message}
//           setMessage={setMessage}
//         />
//       ) : (
//         <>
//           <div className="space-y-[30px]">
//             <MainHeader
//               heading={t(`exercisePlan.exerciseHeaderHeading`)}
//               subheading={t(`exercisePlan.exerciseHeaderSubheading`)}
//               description={t(`exercisePlan.exerciseHeaderDescription`)}
//               Image={HeaderImage}
//             />
//             {generatePlanLoading && (
//               <ExerciseGeneratingLoader
//                 handleFetchExercise={handleFetchExercise}
//                 recreateLoading={true}
//                 planInitiateTime={planInitiateTime}
//                 setGeneratePlanLoading={setGeneratePlanLoading}
//                 timeLeft={timeLeft}
//                 setTimeLeft={setTimeLeft}
//                 message={message}
//                 setMessage={setMessage}
//               />
//             )}

//             <div className="rounded-[12px] p-[24px] bg-white">
//               <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-5">
//                 <h2 className="text-[14px] md:text-[16px] font-[Lato] font-[500] text-black">
//                   {t("exercisePlan.exerciseCategoriesHeading")}
//                 </h2>
//                 <div className="flex items-center gap-2">
//                   <button
//                     className={`bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] mt-2 md:m-0  text-white px-3 min-h-[30px] w-[100%] md:min-w-[182px]  
//                       ${generatePlanLoading && "opacity-70"}
//                       text-[12px] font-[500] font-[Lato] rounded-md`}
//                     onClick={() =>
//                       subscription?.status === "active" ||
//                       subscription?.status === "pending-cancel"
//                         ? handleClickOpen()
//                         : navigate("/renew-subscription")
//                     }
//                     disabled={generatePlanLoading || saveLoad}
//                   >
//                     {saveLoad ? (
//                       <ButtonLoader />
//                     ) : (
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: "5px",
//                         }}
//                         className="justify-center md:justify-start"
//                       >
//                         <SaveAllIcon className="w-5 h-5" />

//                         <span className="">
//                           {t("exercisePlan.confirmGenerateButton")}
//                         </span>
//                       </div>
//                     )}
//                   </button>
//                 </div>
//               </div>

//               <div
//                 className="bg-cover rounded-[12px] p-[24px] gap-4 grid gird-cols-1 "
//                 style={{ backgroundImage: `url(${BackImg})` }}
//               >
//                 {/* Use the local field structure for dynamic rendering */}
//                 {localExercisePreferences.map(({ label, key, type }) => {
//                   const dropdownOptions = getDropdownOptions(key);
//                   const selectedValue = selectedTags[key];
//                   const selectedArray = Array.isArray(selectedValue)
//                     ? selectedValue
//                     : selectedValue
//                     ? [selectedValue]
//                     : [];

//                   return (
//                     <div
//                       key={key}
//                       className="flex flex-col md:flex-row  xs:items-center bg-white gap-2 rounded-[12px] p-3"
//                     >
//                       <div className="flex gap-2 items-center">
//                         <div
//                           className="min-w-[54px] max-w-[54px] max-h-[54px] min-h-[54px] p-2 rounded-full flex items-center justify-center"
//                           style={{ backgroundColor: icons[key].bgColor }}
//                         >
//                           {icons[key].svg}
//                         </div>

//                         <p className="block md:hidden text-black text-[14px] font-[Lato] mb-2 text-black">
//                           {t(`firstFormSteps.${key}.label`)}
//                         </p>
//                       </div>
//                       <div className="flex flex-col flex-1">
//                         <>
//                           <p className="hidden md:block text-black text-[14px] font-[Lato] mb-2 text-black">
//                             {t(`firstFormSteps.${key}.label`)}
//                           </p>

//                           <div className="relative w-full mr-5">
//                             {type === "multi-select" && (
//                               <ExercisePlanMultiSelectDropdown
//                                 options={dropdownOptions.map(
//                                   (opt) => opt.value
//                                 )} // Array of IDs
//                                 selectedValues={selectedTags[key] || []}
//                                 onSelect={(values) =>
//                                   handleMultiSelectChange(key, values)
//                                 }
//                                 label={label}
//                                 hasError={!!errors[key]}
//                                 placeholder="Select options"
//                                 isEditable={true}
//                                 isFistForm={true}
//                                 displayMap={dropdownOptions.reduce(
//                                   (map, opt) => {
//                                     map[opt.value] = opt.label; // Create mapping: {id: "Display Name"}
//                                     return map;
//                                   },
//                                   {}
//                                 )}
//                                 fieldKey={key}
//                               />
//                             )}
//                             {type === "select" ? (
//                               <>
//                                 <select
//                                   className={`border p-2 rounded-md w-[100%] h-10 text-[12px] outline-none bg-white ${
//                                     errors[key] ? "border-red-500" : ""
//                                   }`}
//                                   value={selectedValue || ""}
//                                   onChange={(e) =>
//                                     handleSelectChange(key, e.target.value)
//                                   }
//                                 >
//                                   <option value="" disabled>
//                                     {t("preferences.validation.onlyOne")}
//                                   </option>
//                                   {dropdownOptions.map((option) => (
//                                     <option
//                                       key={option.value}
//                                       value={option.value}
//                                     >
//                                       {option.label}
//                                     </option>
//                                   ))}
//                                 </select>
//                                 {errors[key] && (
//                                   <div className="text-red-500 text-[10px] md:text-[12px] ml-2 mt-1">
//                                     {/* {errors[key]} */}
//                                     {t("validation.required", {
//                                       field: t(`firstFormSteps.${[key]}.label`),
//                                     })}
//                                   </div>
//                                 )}
//                               </>
//                             ) : null}
//                           </div>
//                           <div className="flex flex-wrap gap-2 mt-2">
//                             {/* Display Tags - showing display names but storing IDs/values appropriately */}
//                             {selectedArray.map((itemValue) => (
//                               <span
//                                 key={itemValue}
//                                 className="bg-blue-100 text-blue-600 px-2 py-1 rounded-md text-sm flex items-center"
//                               >
//                                 {getDisplayLabel(key, itemValue)}
//                                 {type === "multi-select" && (
//                                   <button
//                                     onClick={() => removeTag(key, itemValue)}
//                                     className="ml-1 text-blue-400 hover:text-blue-700"
//                                   >
//                                     ✕
//                                   </button>
//                                 )}
//                               </span>
//                             ))}
//                           </div>
//                         </>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//             {exerciseCheck && (
//               <>
//                 <GenerateExcercise
//                   AllExercises={exercisePlan}
//                   start_time={planInitiateTime}
//                 />
//               </>
//             )}
//             {!exerciseCheck && !generatePlanLoading && (
//               <div className="bg-white rounded-[12px] p-[24px]">
//                 <NotFound />
//                 <p className="text-center">
//                   {t("exercisePlan.haveNoPlan")}
//                   <br /> {t("exercisePlan.clickOn")}{" "}
//                   <span
//                     className="text-blue-600 cursor-pointer"
//                     onClick={() =>
//                       subscription?.status === "active" ||
//                       subscription?.status === "pending-cancel"
//                         ? handleClickOpen()
//                         : navigate("/renew-subscription")
//                     }
//                   >
//                     {t("exercisePlan.generatePlan")}
//                   </span>{" "}
//                   {t("exercisePlan.toCreatePlan")}
//                 </p>
//               </div>
//             )}
//           </div>

//           <AlertDialog
//             open={open}
//             handleClose={handleClose}
//             heading={t("Confirm Categories")}
//             message={t(
//               "Are you sure you want to confirm these categories and generate your personalized exercise plan?",
//               {
//                 language: language === "nl" ? "Dutch" : "English",
//               }
//             )}
//           />
//         </>
//       )}
//     </div>
//   );
// };

// export default ExerciseDashboard;



import { useEffect, useState } from "react";
import { initialExercisePreferences } from "data/dropdowndData/dropdownsData";
import GenerateExcercise from "@features/exercise/GenerateExcercise";
import { toast } from "react-toastify";
import ActualDietPlanLoader from "@components/ui/Loaders/ActualDietPlanLoader";
import AlertDialog from "@components/ui/ConfirmDialogue";
import ExerciseGeneratingLoader from "@components/ui/Loaders/ExerciseGeneratingLoader";
import { useUserData } from "context/OAuth/AuthContext";
import { useNavigate } from "react-router-dom";
import MainHeader from "@components/ui/MainHeader";
import HeaderImage from "@assets/images/exercisePlanHeader.svg";
import { useTranslation } from "react-i18next";

import {
  generateExercisePlan,
  getExerciseCategories,
  saveExerciseCategories,
  getExercisePlan,
} from "api/exercisePlan";
import useExercisePlanTimer from "@utils/ExercisePlanProgress";
import { useMeta } from "context/ExerciseMeta";
import { icons, localExercisePreferences } from "data/uiData/ExercisePlan";
import NoExercisePlan from "@features/exercise/NoExercisePlan";
import ExerciseCategoriesDropdown from "@features/exercise/ExerciseCategoriesDropdown";


const ExerciseDashboard = () => {
  const { subscription, language } = useUserData();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [exercisePlan, setExercisePlan] = useState([]);
  const [errors, setErrors] = useState({});
  const [open, setOpen] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const [planInitiateTime, setPlanInitiateTime] = useState(null);
  const [selectedTags, setSelectedTags] = useState(initialExercisePreferences);
  const { timeLeft, setTimeLeft, stopCountdown } = useExercisePlanTimer(
    planInitiateTime,
    900
  );
  const [message, setMessage] = useState("25");
  const { dynamicOptions } = useMeta();
  const [saveLoad, setSaveLoad] = useState(false);
  const [generatePlanLoading, setGeneratePlanLoading] = useState(false);
  const exerciseCheck = exercisePlan?.length > 0;

  // Helper function to find option by ID (for equipment and workouts)
  const findOptionById = (key, id) => {
    const options = dynamicOptions[key];
    if (!options || !Array.isArray(options)) return null;

    return options.find((opt) => opt.id === id);
  };

  const setExercisePlanData = (data, isPending) => {
    setPlanInitiateTime(data?.start_time || null);
    setExercisePlan(data?.plan || null);
    setGeneratePlanLoading(isPending);
  };

  // Data Fetching Functions
  const handleFetchExercise = async (newPlan = false) => {
    try {
      const exercisePlanInfo = await getExercisePlan();
      const data = exercisePlanInfo.data;
      const isPending = data?.is_pending;
      setMessage(data?.loader_status);
      if (newPlan) {
        stopCountdown();
        toast.info(t("Your new Exercise Plan created successfully!"));
      }
      setExercisePlanData(data, isPending);
    } catch (error) {
      console.log("error fetching exercise plan");
    }
  };

  const validateAndMapSavedData = (savedFields, currentDynamicOptions) => {
    const validatedData = {};

    // Equipment Categories - single select (store ID)
    if (savedFields.equipmentCategories) {
      const equipmentOption = currentDynamicOptions.equipmentCategories.find(
        (opt) => opt.id === savedFields.equipmentCategories
      );
      validatedData.equipmentCategories = equipmentOption
        ? savedFields.equipmentCategories
        : null;
    }

    // Difficulties Level - single select (store value directly as it's simple string)
    if (savedFields.difficultiesLevel) {
      const difficultyExists = currentDynamicOptions.difficultiesLevel.includes(
        savedFields.difficultiesLevel
      );
      validatedData.difficultiesLevel = difficultyExists
        ? savedFields.difficultiesLevel
        : null;
    }

    // Workouts Categories - multi-select (store array of IDs)
    if (Array.isArray(savedFields.workoutsCategories)) {
      validatedData.workoutsCategories = savedFields.workoutsCategories.filter(
        (id) => {
          return (
            currentDynamicOptions.workoutsCategories.find(
              (opt) => opt.id === id
            ) !== undefined
          );
        }
      );
    }

    return validatedData;
  };

  const handleFetchCatgories = async () => {
    try {
      const response = await getExerciseCategories();
      await handleFetchExercise();

      const { fields = {} } = response?.data?.data || {};

      // 3. Validate and map saved values to appropriate format using the current options
      const validatedData = validateAndMapSavedData(fields, dynamicOptions);

      // 4. Merge with initial preferences (fallback if no valid data)
      const data = {
        equipmentCategories:
          validatedData.equipmentCategories ||
          initialExercisePreferences.equipmentCategories,
        difficultiesLevel:
          validatedData.difficultiesLevel ||
          initialExercisePreferences.difficultiesLevel,
        workoutsCategories:
          validatedData.workoutsCategories ||
          initialExercisePreferences.workoutsCategories,
      };

      setSelectedTags(data);
      setTimeout(() => {
        setFirstLoad(false);
      }, 1000);
    } catch (error) {
      console.error("Error fetching categories:", error);
      setTimeout(() => {
        setFirstLoad(false);
      }, 1000);
    }
  };

  const getSavePayload = () => {
    const payload = {};
    // Equipment Categories - store ID
    payload.equipmentCategories = selectedTags.equipmentCategories;
    // Difficulties Level - store value directly
    payload.difficultiesLevel = selectedTags.difficultiesLevel;
    // Workouts Categories - store array of IDs
    payload.workoutsCategories = selectedTags.workoutsCategories;

    return payload;
  };

  const handleSaveCategories = async () => {
    setSaveLoad(true);
    try {
      const payload = getSavePayload();
      // const createPlanPayload = buildExercisePayload(
      //   selectedTags,
      //   dynamicOptions
      // );
      await saveExerciseCategories(payload);
      await handleGeneratePlan();
    } catch (error) {
      console.error(error);
      toast.error(t("toast.failedSubmit"));
    } finally {
      setSaveLoad(false);
    }
  };

  const handleGeneratePlan = async () => {
    try {
      const response = await generateExercisePlan();
      setPlanInitiateTime(response?.start_time);
      setMessage(response?.loader_status);
      // setTimeout(() => {
      if (response?.is_pending) {
        setGeneratePlanLoading(true);
        toast.info(t("toast.Plan creation process has been initiated."));
      } else {
        toast.info(t("toast.We've found a matching plan for you!"));
        setExercisePlanData(response, response?.is_pending);
      }
      // }, 1000);
    } catch (error) {
      toast.error(t("toast.Failed to save plan."));
      console.log(error);
    }
  };

  const handleClose = (key) => {
    if (key === "cancel") {
      setOpen(false);
    } else {
      handleSaveCategories();
      setOpen(false);
    }
  };

  const validateStep = () => {
    let isValid = true;
    const newErrors = {};

    for (const field of localExercisePreferences) {
      const value = selectedTags[field.key];
      const fieldLabel = t(`firstFormSteps.${field.key}.label`);

      if (field.type === "multi-select") {
        if (!Array.isArray(value) || value.length === 0) {
          newErrors[field.key] = t("validation.required", {
            field: fieldLabel,
          });
          isValid = false;
        }
      } else if (field.type === "select") {
        if (!value || value === "") {
          newErrors[field.key] = t("validation.required", {
            field: fieldLabel,
          });
          isValid = false;
        }
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleClickOpen = () => {
    if (validateStep()) {
      setOpen(true);
    } else {
      toast.error(t("toast.oopsIncorrect"));
    }
  };

  useEffect(() => {
    handleFetchCatgories(); // This now handles fetching both static and dynamic options
  }, []);

  const handleMultiSelectChange = (key, values) => {
    setSelectedTags((prev) => ({ ...prev, [key]: values }));

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      if (!values || values.length === 0) {
        updatedErrors[key] = true;
      } else {
        delete updatedErrors[key];
      }
      return updatedErrors;
    });
  };

  const handleSelectChange = (key, value) => {
    setSelectedTags((prev) => ({ ...prev, [key]: value }));

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      if (!value || value === "") {
        updatedErrors[key] = true;
      } else {
        delete updatedErrors[key];
      }
      return updatedErrors;
    });
  };

  const removeTag = (key, itemValue) => {
    const updated = selectedTags[key].filter((item) => item !== itemValue);

    if (updated.length === 0) {
      setErrors((prev) => ({ ...prev, [key]: true }));
    }

    setSelectedTags((prev) => ({
      ...prev,
      [key]: updated,
    }));
  };

  /**
   * Gets display label for a given value/ID
   */
  const getDisplayLabel = (key, value) => {
    if (key === "difficultiesLevel") {
      // Difficulties are simple strings, not IDs
      return value ? value.charAt(0).toUpperCase() + value.slice(1) : value;
    }

    // For equipment and workouts, find by ID
    const option = findOptionById(key, value);
    return option ? option.name : "Unknown";
  };

  /**
   * Gets dropdown options for each field type
   */
  const getDropdownOptions = (key) => {
    const options = dynamicOptions[key] || [];

    if (key === "difficultiesLevel") {
      // Simple array of strings - store value directly
      return options.map((opt) => ({
        value: opt, // Store the value directly
        label: opt.charAt(0).toUpperCase() + opt.slice(1),
      }));
    } else {
      // Array of objects - store the ID
      return options.map((opt) => ({
        value: opt.id, // Store ID as value
        label: opt.name, // Display name
      }));
    }
  };

  return (
    <div className={`${firstLoad && "h-[100%]"}`}>
      {firstLoad ? (
        <ActualDietPlanLoader exercisePlan={true} />
      ) : !exerciseCheck && generatePlanLoading ? (
        <ExerciseGeneratingLoader
          planInitiateTime={planInitiateTime}
          exercisePlan={true}
          handleFetchExercise={handleFetchExercise}
          setGeneratePlanLoading={setGeneratePlanLoading}
          timeLeft={timeLeft}
          setTimeLeft={setTimeLeft}
          message={message}
          setMessage={setMessage}
        />
      ) : (
        <>
          <div className="space-y-[30px]">
            <MainHeader
              heading={t(`exercisePlan.exerciseHeaderHeading`)}
              subheading={t(`exercisePlan.exerciseHeaderSubheading`)}
              description={t(`exercisePlan.exerciseHeaderDescription`)}
              Image={HeaderImage}
            />
            {generatePlanLoading && (
              <ExerciseGeneratingLoader
                handleFetchExercise={handleFetchExercise}
                recreateLoading={true}
                planInitiateTime={planInitiateTime}
                setGeneratePlanLoading={setGeneratePlanLoading}
                timeLeft={timeLeft}
                setTimeLeft={setTimeLeft}
                message={message}
                setMessage={setMessage}
              />
            )}

            <ExerciseCategoriesDropdown
              selectedTags={selectedTags}
              errors={errors}
              localExercisePreferences={localExercisePreferences}
              icons={icons}
              getDropdownOptions={getDropdownOptions}
              getDisplayLabel={getDisplayLabel}
              handleMultiSelectChange={handleMultiSelectChange}
              handleSelectChange={handleSelectChange}
              removeTag={removeTag}
              subscription={subscription}
              generatePlanLoading={generatePlanLoading}
              saveLoad={saveLoad}
              handleClickOpen={handleClickOpen}
              navigate={navigate}
              t={t}
            />

            {exerciseCheck && (
              <GenerateExcercise
                AllExercises={exercisePlan}
                start_time={planInitiateTime}
              />
            )}

            <NoExercisePlan
              exerciseCheck={exerciseCheck}
              generatePlanLoading={generatePlanLoading}
              subscription={subscription}
              handleClickOpen={handleClickOpen}
              navigate={navigate}
            />
          </div>

          <AlertDialog
            open={open}
            handleClose={handleClose}
            heading={t("Confirm Categories")}
            message={t(
              "Are you sure you want to confirm these categories and generate your personalized exercise plan?",
              {
                language: language === "nl" ? "Dutch" : "English",
              }
            )}
          />
        </>
      )}
    </div>
  );
};

export default ExerciseDashboard;